import { memo, useSyncExternalStore } from 'react';
import { ColorPicker } from '@/components/atoms/ColorPicker/ColorPicker';
import { brandKit } from '@/stores/brandKit';

interface Props {
  label: string;
  value: string;
  onChange: (value?: string) => void;
  testId?: string;
}

const SpeakerLabelColorPicker = memo(({ label, value, onChange, testId }: Props) => {
  const brandKitStore = useSyncExternalStore(brandKit.subscribe, brandKit.getSnapshot);

  return (
    <div className="flex w-full items-center justify-between">
      <span className="text-xs font-medium text-gray-700">{label}</span>
      <div className="relative flex size-8 flex-1 items-center justify-end gap-2">
        <div className="rounded bg-slate-100 px-2 py-1">
          <div className="font-mono text-xs text-gray-500">{value.toUpperCase()}</div>
        </div>
        <ColorPicker
          classNames="rounded-2xl w-7 h-7 justify-center items-center"
          pickerClassNames="left-full ml-1 top-0"
          defaultColors={brandKitStore.colors}
          defaultColorsLabel="Brand Colors"
          onChange={onChange}
          hex={value}
          data-testid={testId}
        />
      </div>
    </div>
  );
});

export default SpeakerLabelColorPicker;
